
  import createMeisterIcons from '../src/createMeisterIcons';

  const HeartrateLine = createMeisterIcons("heartrate-line", [["path",{"fill":"currentColor","d":"m9.715 6.53 2.962 12.747.011.033c.16.48.592.72.939.778.349.058.972-.04 1.185-.678l1.995-5.987H19.5a.75.75 0 1 0 0-1.5h-2.9c-.513 0-.804.292-.92.409l-.01.01-.126.126-1.714 5.143-3.007-12.942-.011-.033c-.183-.549-.699-.738-1.062-.738s-.879.189-1.061.738l-.006.017-2.008 7.17H4.5a.75.75 0 0 0 0 1.5h2.4c.513 0 .804-.292.92-.409l.01-.01.14-.14z","key":"2db5560205fa61496d809fbbcb5deeb9b4dbc28d","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default HeartrateLine
  